import styled from 'styled-components';
import GridContainer from '@stelecom/ui-react/components/layouts/gridContainer';

export const Wrapper = styled(GridContainer)`
  display: block;
  margin-top: 22px;
  
  > div:first-child {
    margin: 0;
    
    @media (max-width: 767px) {
        padding: 0;
    }
  }
`;
